import { FilterTag } from 'modules/notifications/components/FilterTag';
import {
  EAdditionalNotificationsFilter,
  ENotificationsFilter,
} from 'modules/notifications/const';
import { useUnseenNotificationsCounts } from 'modules/notifications/hooks/useUnseenNotificationsCounts';

import { useFiltersStyles } from './useFiltersStyles';

interface IFiltersProps {
  activeFilter: ENotificationsFilter;
  handleChangeFilter: (filter: ENotificationsFilter) => void;
}

export const Filters = ({
  activeFilter,
  handleChangeFilter,
}: IFiltersProps) => {
  const { classes } = useFiltersStyles();

  const { total } = useUnseenNotificationsCounts();

  return (
    <div className={classes.root}>
      <FilterTag
        isTransparent
        isActive={activeFilter === EAdditionalNotificationsFilter.ALL}
        shouldHideIcon
        shouldShowAmountInBraces
        category={EAdditionalNotificationsFilter.ALL}
        handleChangeFilter={handleChangeFilter}
      />
      <FilterTag
        isTransparent
        amount={total}
        isActive={activeFilter === EAdditionalNotificationsFilter.UNREAD}
        shouldShowAmountInBraces
        shouldHideIcon
        category={EAdditionalNotificationsFilter.UNREAD}
        handleChangeFilter={handleChangeFilter}
      />
    </div>
  );
};
